import { useEffect } from 'react';
import { hasUserConsented } from './consent';
import { ShopifyConfig } from './types';

export const useShopifyConsentScript = (
   shopifyConsentSync: boolean,
   piwikSiteId: string,
   shopifyConfig: ShopifyConfig,
   needsConsent: boolean
) => {
   useEffect(() => {
      if (!shopifyConsentSync) {
         return;
      }

      const script = document.createElement('script');
      script.src =
         'https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js?shpxid=c0d65ea6-DB5F-41EB-BE8D-E48D42A4B775';
      script.async = true;
      script.onload = () => {
         const userConsent = hasUserConsented(piwikSiteId) ?? !needsConsent;
         /* eslint-disable-next-line no-console */
         console.log('Sending consent to Shopify:', userConsent);
         window.Shopify?.customerPrivacy?.setTrackingConsent({
            'marketing': userConsent,
            'analytics': userConsent,
            'preferences': userConsent,
            'sale_of_data': userConsent,
            'headlessStorefront': true,
            'checkoutRootDomain': shopifyConfig.checkout,
            'storefrontRootDomain': shopifyConfig.storefront,
            'storefrontAccessToken': shopifyConfig.accessToken,
         });
      };

      document.body.append(script);

      return () => {
         script.remove();
      };
   }, [shopifyConsentSync, piwikSiteId, shopifyConfig, needsConsent]);
};
